import { List, TextField, EditButton, SimpleList, Datagrid, DeleteButton, TopToolbar, CreateButton } from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { settings } from "app";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { IbansExporter } from "./XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";

const ListIbans = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={IbansExporter} />
      </TopToolbar>
    );
  };

  return (
    <List
      title="IBANS"
      sx={settings.style.expandStyle}
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateIbanDetails)} />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "IBAN", value: record.ibanNumber }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "BIC код за плащане в лева", value: record.bic }]} />
              <MobileListRow fields={[{ label: "BIC код за плащане във валута", value: record.bicForeign }]} />
              <MobileListRow fields={[{ label: "SWIFT код", value: record.swiftCode }]} />
              <MobileListRow fields={[{ label: "Банков код", value: record.bankCode }]} />
              <MobileListRow fields={[{ label: "Име на банка", value: record.bankName }]} />
              <MobileListRow fields={[{ label: "Име на получател на български език", value: record.recipientNames }]} />
              <MobileListRow fields={[{ label: "Име на получател на английски език", value: record.recipientNamesEn }]} />
            </div>
          )}
          tertiaryText={record => (
            <>
              {checkPermission(userPermissions, permissions.canUpdateIbanDetails) && <EditButton label="" />}
              {checkPermission(userPermissions, permissions.canDeleteIbanDetails) && <DeleteButton label="" />}
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="ibanNumber"
            label="IBAN"
            sortable={false}
          />
          <TextField
            source="bic"
            label="BIC код за плащане в лева"
            sortable={false}
          />
          <TextField
            source="bicForeign"
            label="BIC код за плащане във валута"
            sortable={false}
          />
          <TextField
            source="swiftCode"
            label="SWIFT код"
            sortable={false}
          />
          <TextField
            source="bankCode"
            label="Банков код"
            sortable={false}
          />
          <TextField
            source="bankName"
            label="Име на банка"
            sortable={false}
          />
          <TextField
            source="recipientNames"
            label="Име на получател на български език"
            sortable={false}
          />
          <TextField
            source="recipientNamesEn"
            label="Име на получател на английски език"
            sortable={false}
          />
          {checkPermission(userPermissions, permissions.canUpdateIbanDetails) && <EditButton />}
          {checkPermission(userPermissions, permissions.canDeleteIbanDetails) && <DeleteButton />}
        </Datagrid>
      )}
    </List>
  );
};
export default ListIbans;
